import { render } from "./TertiaryButton.vue?vue&type=template&id=3a3b4e40&scoped=true"
import script from "./TertiaryButton.vue?vue&type=script&lang=js"
export * from "./TertiaryButton.vue?vue&type=script&lang=js"

import "./TertiaryButton.vue?vue&type=style&index=0&id=3a3b4e40&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a3b4e40"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
